import { Link } from "gatsby"
import React, { useState } from "react"
import navigationV2 from "../content/navigation-v2"
import Logo from "../images/inpowered-logo-light.inline.svg" // ⬅️ adicionada a logo

const isExternal = href => /^https?:\/\//.test(href)
const isHash = to => typeof to === "string" && to.startsWith("#")

/**
 * @param {{navigation: Array<{to: string, text: string, isButton?: boolean}>}} param0
 */
const Header = ({ navigation = navigationV2 }) => {
  const [isExpanded, setExpansion] = useState(false)
  const year = new Date().getFullYear()

  const renderDesktopItem = ({ to, text, isButton }) => {
    const key = `${text}-${to}`

    if (isButton) {
      if (isExternal(to)) {
        return (
          <div className="navbar-item" key={key}>
            <a
              href={to}
              className="button is-rounded is-link"
              rel="noopener noreferrer"
            >
              {text}
            </a>
          </div>
        )
      }
      if (isHash(to)) {
        return (
          <div className="navbar-item" key={key}>
            <a href={to} className="button is-rounded is-link">
              {text}
            </a>
          </div>
        )
      }
      return (
        <div className="navbar-item" key={key}>
          <Link to={to} className="button is-rounded is-link">
            {text}
          </Link>
        </div>
      )
    }

    if (isExternal(to)) {
      return (
        <a
          href={to}
          key={key}
          className="navbar-item has-text-white"
          rel="noopener noreferrer"
        >
          {text}
        </a>
      )
    }
    if (isHash(to)) {
      return (
        <a href={to} key={key} className="navbar-item has-text-white m-2">
          {text}
        </a>
      )
    }
    return (
      <Link to={to} key={key} className="navbar-item has-text-white">
        {text}
      </Link>
    )
  }

  const renderMobileItem = ({ to, text, isButton }) => {
    const key = `${text}-${to}`
    const cls = isButton
      ? "button is-rounded is-link is-fullwidth mt-5"
      : "has-text-white py-3 px-1"

    if (isExternal(to)) {
      return (
        <a
          href={to}
          key={key}
          className={cls}
          rel="noopener noreferrer"
          onClick={() => setExpansion(false)}
        >
          {text}
        </a>
      )
    }
    if (isHash(to)) {
      return (
        <a
          href={to}
          key={key}
          className={cls}
          onClick={() => setExpansion(false)}
        >
          {text}
        </a>
      )
    }
    return (
      <Link
        to={to}
        key={key}
        className={cls}
        onClick={() => setExpansion(false)}
      >
        {text}
      </Link>
    )
  }

  return (
    <div className="header-wrapper has-background-dark">
      <nav
        className="navbar container py-4-mobile px-5-mobile has-background-dark"
        role="navigation"
        aria-label="main navigation"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: "70px",
        }}
      >
        <Link
          to="/"
          className="logo"
          aria-label="Home"
          style={{ height: "30.6px", width: "150px", marginLeft: 20 }}
        >
          <Logo style={{ height: "100%", width: "100%" }} />
        </Link>

        <nav
          className="navbar is-hidden-mobile has-background-dark"
          role="navigation"
          aria-label="dropdown navigation"
        >
          {navigation.map(renderDesktopItem)}
        </nav>

        <div
          className="is-flex is-hidden-tablet"
          style={{ alignItems: "center" }}
        >
          <button
            aria-label="menu"
            aria-expanded={isExpanded}
            onClick={() => setExpansion(!isExpanded)}
            className={`navbar-burger has-text-white ${
              isExpanded ? "is-active" : ""
            }`}
            style={{ background: "transparent", border: 0 }}
            type="button"
          >
            <span aria-hidden="true" />
            <span aria-hidden="true" />
            <span aria-hidden="true" />
          </button>
        </div>

        {isExpanded && (
          <div className="mobile-overlay-menu has-background-dark is-hidden-tablet">
            <nav className="mobile-overlay-menu--nav py-3 px-5">
              {navigation.map(renderMobileItem)}
            </nav>
            <div className="mobile-overlay-menu--footer py-4">
              <div className="op-6 is-size-7 has-text-white">
                © Copyright {year} inPowered
              </div>
            </div>
          </div>
        )}
      </nav>
    </div>
  )
}

export default Header
